import { Injectable } from '@angular/core';
import { IAppPluginWidget } from 'core-client/api'
import { NgsildConnectorService, IQueryIdPatternArgs } from 'ngsild-connector'
import { IMapWidgetFormGroupEntities } from '../../../map/map-widget-settings/map-widget-settings.interface'
import { NgsiIdPrefix } from '../../../map/lib/ngsild/helpers/ngsild.constants'

@Injectable({
  providedIn: 'root'
})
export class UtilsService {
  static hasRegisteredNgsiEntities(appPluginWidget: IAppPluginWidget): boolean {
    return appPluginWidget?.settings !== undefined && appPluginWidget.settings?.['entities'] !== undefined
  }

  static async generateQueryString(entities: IMapWidgetFormGroupEntities[], ngsildConnectorService: NgsildConnectorService): Promise<IQueryIdPatternArgs> {
    const uuid = await ngsildConnectorService.uuidFromSettings()
    const queryString = entities
      .map((entity: IMapWidgetFormGroupEntities) => `${NgsiIdPrefix}${entity.id}`)
      .join(',');

    return { uuid: uuid, idPattern: queryString}
  }
}
